import { ActualsValueTypes } from 'partner360/models/actualValueTypes'
import { QBRRounding } from 'partner360/models/qbr/QBRRounding'

interface IGetCalculated {
  netNdp: ActualsValueTypes
  currency: string
  rounding: QBRRounding
  ifNoValueIsZero?: boolean
}

const getRoundingValue = (value: number, rounding: QBRRounding) => {
  if (rounding === QBRRounding.M) {
    return value / 1000000
  }

  if (rounding === QBRRounding.K) {
    return value / 1000
  }
  return value
}

export const getCalculatedValueDependOnSettings =
  <T>({ currency, rounding, netNdp, ifNoValueIsZero }: IGetCalculated) =>
  (el: T, fields: string[]) => {
    const currencyType = currency === 'USD' ? 'USD' : 'LocalCurrency'
    const postFix = `${netNdp}${currencyType}`
    const field = fields.find((el) => el.endsWith(postFix))

    if (!field) {
      return 0
    }

    if (ifNoValueIsZero && !el[field]) {
      return 0
    }

    return getRoundingValue(el[field], rounding)
  }
